<template>
  <div class="wos-form">
    <div class="row wos-form-row">
      <DxCheckBox
        v-model="localData.view_scale_ticket"
        :text="$t('scale.weighing_on_scale.view_scale_ticket')"
      >
      </DxCheckBox>
    </div>
    <div class="row wos-form-row">
      <DxCheckBox
        v-model="localData.create_inventory_movement"
        :disabled="isStockMovementDisabled"
        :text="$t('scale.weighing_on_scale.create_inventory_movement')"
      >
      </DxCheckBox>
    </div>
  </div>
</template>

<script>
import { DxCheckBox } from "devextreme-vue/check-box";
import { FIELD_REPORT_MODES, WEIGHING_TYPES } from "@/pages/scale/config/weighingTypes";

export default {
  name: "wosForm",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData }, // Create a local copy of formData
    };
  },
  computed: {
    isStockMovementDisabled() {
      const isContractedMeasurements = parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.CONTRACTED_MEASUREMENTS;
      const isTransportFieldReport =
        parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT &&
        parseInt(this.localData.field_report_type) === FIELD_REPORT_MODES.WEIGHING_FOR_TRANSPORT;

      return isContractedMeasurements || isTransportFieldReport;
    },
  },
  components: {
    DxCheckBox,
  },
  methods: {
    validate() {
      return {
        error: false,
        message: "",
      };
    },
    refreshCheckboxStatuses(newData) {
      // no inventory movements when weighing type is 5
      if (
        parseInt(this.localData.weighing_type_id) != newData.weighing_type_id
      ) {
        this.localData.weighing_type_id = newData.weighing_type_id;
      }

      if (parseInt(this.localData.field_report_type) !== parseInt(newData.field_report_type)) {
        this.localData.field_report_type = newData.field_report_type;
      }

      if (this.isStockMovementDisabled) {
        this.localData.create_inventory_movement = false;
      }

      // no scale ticket view and stock movments when full or empty weight is 0
      /*if (
        parseFloat(this.localData.full_weight_kg) !=
          parseFloat(newData.full_weight_kg) ||
        parseFloat(this.localData.empty_weight_kg) !=
          parseFloat(newData.empty_weight_kg)
      ) {
        if (
          (newData.full_weight_kg ?? 0) == 0 ||
          (newData.empty_weight_kg ?? 0) == 0
        ) {
          this.localData.create_inventory_movement = false;
          this.localData.view_scale_ticket = false;
        } else {
          this.localData.view_scale_ticket = true;
        }
      }*/
    },
  },
  watch: {
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-form-data", newData, this.number); // Emit updated data to parent
      },
    },
    formData: {
      deep: true,
      handler(newData) {
        if (this.isStockMovementDisabled) {
          this.localData.create_inventory_movement = false;
        }
        this.refreshCheckboxStatuses(newData); // Refresh checkbox statuses based on new data
      },
    },
  },
};
</script>

<style scoped>
.wos-form {
  height: 100%;
  width: 100%;
}

.wos-form-row {
  margin-bottom: 20px;
}
</style>
